import { Breadcrumb } from '@repo/ui/components/ui/breadcrumb';
import { Card } from '@repo/ui/components/ui/card';
import { UserForm } from '@repo/ui/features/user/user-form';
import { PageHeader } from '@repo/ui/ui/layout/page-header';
import { useNavigate } from 'react-router-dom';

export default function UtilisateurCreatePage() {
  const navigate = useNavigate();
  const goToList = () => navigate('/admin/droits/utilisateur');

  return (
    <div className="space-y-4">
      <div className="mb-2">
        <Breadcrumb
          items={[
            { label: 'Gestion' },
            { label: 'Utilisateurs', href: '/admin/droits/utilisateur' },
            { label: 'Créer un utilisateur', current: true },
          ]}
          showHomeIcon
          onHomeClick={() => navigate('/admin/dashboard')}
          className="mb-4"
        />
      </div>

      <PageHeader>
        <PageHeader.Title>Créer un Utilisateur</PageHeader.Title>
      </PageHeader>

      <Card className="p-4">
        <UserForm onCancel={goToList} onSuccess={goToList} />
      </Card>
    </div>
  );
}
